/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupWithControlCountDto } from './GroupWithControlCountDto';
import {
    GroupWithControlCountDtoFromJSON,
    GroupWithControlCountDtoFromJSONTyped,
    GroupWithControlCountDtoToJSON,
    GroupWithControlCountDtoToJSONTyped,
} from './GroupWithControlCountDto';

/**
 * 
 * @export
 * @interface GroupListWithCountsResponse
 */
export interface GroupListWithCountsResponse {
    /**
     * 
     * @type {Array<GroupWithControlCountDto>}
     * @memberof GroupListWithCountsResponse
     */
    data?: Array<GroupWithControlCountDto>;
    /**
     * 
     * @type {number}
     * @memberof GroupListWithCountsResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupListWithCountsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupListWithCountsResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the GroupListWithCountsResponse interface.
 */
export function instanceOfGroupListWithCountsResponse(value: object): value is GroupListWithCountsResponse {
    return true;
}

export function GroupListWithCountsResponseFromJSON(json: any): GroupListWithCountsResponse {
    return GroupListWithCountsResponseFromJSONTyped(json, false);
}

export function GroupListWithCountsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupListWithCountsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GroupWithControlCountDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GroupListWithCountsResponseToJSON(json: any): GroupListWithCountsResponse {
    return GroupListWithCountsResponseToJSONTyped(json, false);
}

export function GroupListWithCountsResponseToJSONTyped(value?: GroupListWithCountsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GroupWithControlCountDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

